import type { SxProps } from '@mui/system/styleFunctionSx';
import { forwardRef } from 'react';
import { CanvasModeComponent } from './canvas_mode';
import { CropModeComponent } from './crop_mode';

export interface DragDropFileUploadProps {
  onUploadComplete?: (url: string) => void;
  onUploadError?: (error: Error) => void;
  size?: 'small' | 'medium';
  sx?: SxProps;
  initialAspectRatio?: number;
  minPixel?: number;
  maxPixel?: number;
  value?: {
    url: string;
    width: number;
    height: number;
  };
  onChange?: (value: { url: string; width: number; height: number }) => void;
  canvasMode?: boolean; // 是否启用Canvas模式
  error?: boolean;
  helperText?: string;
}

/**
 * 拖拽上传组件 - 路由组件
 * 根据 canvasMode 属性选择对应的实现：
 * - canvasMode=true: 使用Canvas模式（支持多图拼接和Canvas编辑）
 * - canvasMode=false: 使用传统裁剪模式
 */
export const DragDropFileUpload = forwardRef<HTMLDivElement, DragDropFileUploadProps>((props, ref) => {
  const { canvasMode = false } = props;

  // 根据 canvasMode 选择对应的组件
  if (canvasMode) {
    return <CanvasModeComponent {...props} ref={ref} />;
  } else {
    return <CropModeComponent {...props} ref={ref} />;
  }
});

DragDropFileUpload.displayName = 'DragDropFileUpload';
